import(/* webpackMode: "eager", webpackExports: ["BooksList"] */ "/vercel/path0/app/books/books-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Zoom","Image"] */ "/vercel/path0/components/ui/image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.1.11_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
